// extracted by mini-css-extract-plugin
module.exports = {"tooltipFormat":"Graph_tooltipFormat__2jzXI","legendsContainer":"Graph_legendsContainer__3Kx3U","tooltipLine":"Graph_tooltipLine__2ZjrA","legendsTitle":"Graph_legendsTitle__3TLWB"};